import React from 'react';
import { IProps, IChildElement } from 'components/Promotions/InnerPage/Schemes/types';
import InnerPageASchemes from 'components/Promotions/InnerPage/Schemes/InnerPageASchemes';
import InnerPageBSchemes from 'components/Promotions/InnerPage/Schemes/InnerPageBSchemes';
import InnerPageCSchemes from 'components/Promotions/InnerPage/Schemes/InnerPageCSchemes';

const Schemes: React.FC<IProps> & IChildElement = (props) => (
  <div className="schemes">
    {props.children}
  </div>
);

Schemes.InnerPageASchemes = InnerPageASchemes;
Schemes.InnerPageBSchemes = InnerPageBSchemes;
Schemes.InnerPageCSchemes = InnerPageCSchemes;

export default Schemes;
